// export const API_BASE = "http://localhost:5000/api/v1";
export const API_BASE = "https://appacademy-api.cyclic.app/api/v1";
